import { CountryCode } from '@constants'
import { createRequestHelper } from '@utils/swr'
import { type FortuneApis } from '../types/apis'
import { type BlockoutDeliveryDaysRequest, type BlockoutDeliveryDaysResponse } from '../types/dataModel/blockout-delivery-date'

export const useApiBlockoutDeliveryDays = createRequestHelper<
  FortuneApis['get']['blockoutDeliveryDays'],
  BlockoutDeliveryDaysResponse,
  BlockoutDeliveryDaysRequest
>({
  client: 'fortune',
  key: (params) => {
    const { project_code, country_code, platform, shipping_method, pre_order_delivery_date } = params || {}
    if (!project_code || !country_code || !platform) return null
    const countryCode = country_code === CountryCode.MO ? CountryCode.HK : country_code
    const optionalQuery = [
      shipping_method ? `&shipping_method=${shipping_method}` : '',
      pre_order_delivery_date ? `&pre_order_delivery_date=${pre_order_delivery_date}` : '',
    ].join('')
    return `/blockout-delivery-days?project_code=${project_code}&country_code=${countryCode}&platform=${platform}${optionalQuery}` as const
  },

  isImmutable: true,
}).useRequest
